import React from 'react';
import Chip from '../Chip';
import colors from '../../scss/_colors-export.module.scss';

export enum ContentType {
  Research = 'Research',
  News = 'News',
  Covenants = 'Covenants',
  Financials = 'Financials',
  RiskProducts = 'Risk Products',
}

interface ContentTypeTagProps {
  contentType?: ContentType | string;
  dataTestId?: string;
  short?: boolean;
}

const ContentTypeTag = ({ contentType, dataTestId, short }: ContentTypeTagProps): React.ReactElement | null => {
  if (!contentType) {
    return null;
  }
  const colorKey = contentType.toLowerCase().replace(' ', '-');
  return (
    <Chip
      label={contentType}
      dataTestId={dataTestId}
      short={short}
      shortLabel={contentType === ContentType.RiskProducts ? 'Q' : undefined}
      color={colors[`${colorKey}-font-color`]}
      backgroundColor={colors[`${colorKey}-bg-color`]}
    />
  );
};

export default ContentTypeTag;
